export default __webpack_public_path__ + "static/media/profilePictureEdit.d38c0fac.jpg";